// extracted by mini-css-extract-plugin
export default {"dialog":"ErrorDialog_dialog__rW9gv","title":"ErrorDialog_title__Cbz7s","actions":"ErrorDialog_actions__jT5vx","singleAction":"ErrorDialog_singleAction__ufPAt"};